import { writeContactsToLoki, writeOrgsToLoki, writeOrgContactsToLoki, deleteOldEnterpriseFromLokiByType } from './contact_sync_enterprise_loki';
export class ContactSyncEnterpriseNew {
    constructor() {
        this.ctx = null;
    }
    init(ctx) {
        this.ctx = ctx;
    }
    destroy() {
        this.ctx = null;
    }
    async doSync(domain, _account, sessionId) {
        var _a, _b;
        if (!this.ctx) {
            return { hasAllContacts: undefined, lastUpdateTime: 0, dexiePromise: Promise.resolve() };
        }
        const ctx = this.ctx;
        const enterpriseId = ctx.systemApi.getCurrentCompanyId(_account);
        const dbAccount = ((_a = ctx.systemApi.getCurrentUser(_account)) === null || _a === void 0 ? void 0 : _a.accountMd5) || _account;
        const currentCompany = ((_b = ctx.systemApi.getCurrentUser(_account)) === null || _b === void 0 ? void 0 : _b.company) || '';
        const result = await ctx.contactServer.fetchNewEnterpriseAll({ domain, _account, enterpriseId, currentCompany });
        if (!result) {
            console.warn('[ContactSyncEnterpriseNew] fetchNewEnterpriseAll failed, skip sync');
            return { hasAllContacts: undefined, lastUpdateTime: 0, dexiePromise: Promise.resolve() };
        }
        const { hasAllContacts, orgs, contacts, contactItems, orgContacts, lastUpdateTime: writeTimestamp, serverLastUpdateTime } = result;
        const tracker = ctx.tracker;
        const resolvedSessionId = sessionId !== null && sessionId !== void 0 ? sessionId : '';
        let dexiePromise;
        const taskType = 'enterprise';
        if (hasAllContacts === 1) {
            await deleteOldEnterpriseFromLokiByType(ctx.lokiApi, { _dbAccount: dbAccount });
            await Promise.all([
                writeOrgsToLoki(ctx.lokiApi, orgs, dbAccount).then(() => {
                    tracker === null || tracker === void 0 ? void 0 : tracker.updateLokiProgress(resolvedSessionId, taskType, 'org', { written: orgs.length, total: orgs.length, status: 'done' }, domain);
                }),
                writeContactsToLoki(ctx.lokiApi, contacts, contactItems, dbAccount).then(() => {
                    tracker === null || tracker === void 0 ? void 0 : tracker.updateLokiProgress(resolvedSessionId, taskType, 'contact', { written: contacts.length, total: contacts.length, status: 'done' }, domain);
                }),
                writeOrgContactsToLoki(ctx.lokiApi, orgContacts, dbAccount).then(() => {
                    tracker === null || tracker === void 0 ? void 0 : tracker.updateLokiProgress(resolvedSessionId, taskType, 'orgContact', { written: orgContacts.length, total: orgContacts.length, status: 'done' }, domain);
                }),
            ]);
            tracker === null || tracker === void 0 ? void 0 : tracker.updateTaskProgress(resolvedSessionId, taskType, { serverContactCount: contacts.length, serverOrgCount: orgs.length }, domain);
            dexiePromise = Promise.resolve()
                .then(async () => {
                await ctx.contactDB.deleteAllEnterpriseOrgsFromDexie({ _account });
                await ctx.contactDB.writeNewEnterpriseToDexie({ orgs, contacts, contactItems, orgContacts, _account });
                await ctx.contactDB.deleteOldEnterpriseDataByType({
                    lastUpdateTime: writeTimestamp,
                    _account,
                });
                tracker === null || tracker === void 0 ? void 0 : tracker.updateTaskProgress(resolvedSessionId, taskType, { phase: 'done' }, domain);
            })
                .catch(err => {
                console.error('[ContactSyncEnterpriseNew] dexie background write failed (hasAllContacts=1)', err);
            });
            console.log(`[ContactSyncEnterpriseNew] sync done (hasAllContacts=1). domain=${domain}, enterpriseId=${enterpriseId}, orgs=${orgs.length}, contacts=${contacts.length}`);
        }
        else {
            await deleteOldEnterpriseFromLokiByType(ctx.lokiApi, { _dbAccount: dbAccount });
            await writeOrgsToLoki(ctx.lokiApi, orgs, dbAccount);
            dexiePromise = Promise.resolve()
                .then(async () => {
                await ctx.contactDB.deleteAllEnterpriseOrgsFromDexie({ _account });
                await ctx.contactDB.writeNewEnterpriseToDexie({ orgs, contacts: [], contactItems: [], orgContacts: [], _account });
                await ctx.contactDB.deleteAllEnterpriseContactsByType({ _account });
                tracker === null || tracker === void 0 ? void 0 : tracker.updateTaskProgress(resolvedSessionId, taskType, { phase: 'done' }, domain);
            })
                .catch(err => {
                console.error('[ContactSyncEnterpriseNew] dexie background write failed (hasAllContacts=0)', err);
            });
            console.log(`[ContactSyncEnterpriseNew] sync done (hasAllContacts=0). domain=${domain}, enterpriseId=${enterpriseId}, orgs=${orgs.length}`);
        }
        return { hasAllContacts, lastUpdateTime: serverLastUpdateTime, dexiePromise };
    }
}
